module.exports = __webpack_public_path__ + "media/images/ac_templates/201/igoht-ec15520d78b9b7d543f47e848f8addd2.jpg";